module.exports = __webpack_public_path__ + "img/add_24px.ce9de641.svg";